module.exports = __webpack_public_path__ + "media/ruoyi_06_有点危险.8699070a.wav";